var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FacebookIconLayer",
    "data-name": "Facebook Icon Layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 39.55 39.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .facebook-icon-cls-1{fill:none;stroke-miterlimit:10;stroke-width:3px;stroke:url(#facebook-icon-linear-gradient);}.facebook-icon-cls-2{fill:url(#facebook-icon-linear-gradient-2);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon-linear-gradient",
    y1: 19.77,
    x2: 39.55,
    y2: 19.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5ac3b2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#29b8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon-linear-gradient-2",
    x1: 44.33,
    y1: 49.95,
    x2: 55.16,
    y2: 49.95,
    xlinkHref: "#facebook-icon-linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "facebook-icon-cls-1",
    x: 1.5,
    y: 1.5,
    width: 36.55,
    height: 36.55,
    rx: 12.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon-cls-2",
    d: "M53.45,43.3h1.71V39.57H52.58c-3.65,0-5.39,2.17-5.39,5.27v2.93H44.33v3.55h2.86v9h4.3v-9h2.86l.81-3.54H51.49V45.36A1.89,1.89,0,0,1,53.45,43.3Z",
    transform: "translate(-30.2 -30.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.f8f570ff597d9093b9113a2ce8ee573a.svg";
export { ForwardRef as ReactComponent };